import React from "react";
import styles from "./shipment-status-badge.module.css";
import { getReadableStatus } from "@/app/fba/utils";

type ShipmentStatusBadgeProps = {
  status: string;
};

const ShipmentStatusBadge = ({
  status,
}: ShipmentStatusBadgeProps) => {
  const readableStatus = getReadableStatus(status);

  return (
    <div className={`
      ${styles.badgeContainer}
      ${status === "SHIPPED" ? styles.shipped : ""}
      ${(status === "RECEIVING" || status === "LISTED") ? styles.receiving : ""}
      ${(status === "ERROR" || status === "CANCELLED") ? styles.error : ""}
    `}>
      {readableStatus}
    </div>
  );
};

export default ShipmentStatusBadge;